import * as React from 'react';
import * as style from './Socials.css';
import { TSocials } from '../../../common/types/socials';

type TSocialsProps = {
  socials: TSocials[];
};

export const Socials: React.FC<TSocialsProps> = ({ socials }) => {
  return (
    <div className={style['social-links']}>
      {socials.map((social, index) => (
        <a
          key={index}
          className={style['social-links']}
          href={social.url}
          target="_blank"
          aria-label={social.name}
          rel="noreferrer"
        >
          <div className={style[social.name]} />
        </a>
      ))}
    </div>
  );
};
